class CustomAccordion extends HTMLElement {
  constructor() {
    super();
    this.accordionTrigger = this.querySelector(".custom-accordion-trigger");
    this.accordionWrapper = this.querySelector(".custom-accordion-wrapper");
    this.initialHeight =
      this.querySelector(".custom-accordion-trigger").offsetHeight + 64;
    this.inProgress = false;
  }

  connectedCallback() {
    this.style.height = `${this.initialHeight}px`;
    let accordion = this;
    setTimeout(() => {
      accordion.style.transition = "height 0.3s ease, opacity 0.3s ease";
      accordion.style.opacity = 1;
    }, 200);
    this.setFullHeight();
    if (this.accordionWrapper.classList.contains("open")) {
      this.openAccordion();
    }
    this.accordionTrigger.addEventListener(
      "click",
      this.updateHeight.bind(this)
    );
    window.addEventListener("resize", this.setFullHeight.bind(this));

    if (this.classList.contains("initially-opened")) {
      this.openAccordion();
    }
  }

  setFullHeight() {
    const titleHeight = this.querySelector(
      ".custom-accordion-trigger"
    ).offsetHeight;
    const contentHeight = this.querySelector(
      ".custom-accordion__content"
    ).offsetHeight;
    this.fullHeight = titleHeight + contentHeight + 64;
  }

  updateHeight(e) {
    if (!this.inProgress) {
      this.inProgress = true;
      if (this.accordionWrapper.classList.contains("open")) {
        this.closeAccordion();
      } else {
        this.parent = this.parentElement;
        this.closeOtherAccordions(this.parent);
        this.openAccordion();
      }
      let tempAccordion = this;
      setTimeout(() => {
        tempAccordion.inProgress = false;
      }, 400);
    }
  }

  openAccordion() {
    let content = this.querySelector(".custom-accordion__content");
    this.style.height = `${this.fullHeight}px`;
    this.accordionWrapper.classList.add("open");
    content.style.opacity = 1;
  }

  closeAccordion() {
    let content = this.querySelector(".custom-accordion__content");
    this.style.height = `${this.initialHeight}px`;
    setTimeout(() => {
      content.style.opacity = 0;
    }, 100);
    this.accordionWrapper.classList.remove("open");
  }

  closeOtherAccordions(parent) {
    parent.querySelectorAll("custom-accordion").forEach((accordion) => {
      if (accordion !== this) {
        accordion.closeAccordion();
      }
    });
  }
}

if (!window.customElements.get("custom-accordion")) {
  window.customElements.define("custom-accordion", CustomAccordion);
}

class GetAQuote extends HTMLElement {
  constructor() {
    super();
    this.step1 = this.querySelector('.get-a-quote-form-step[data-step="1"]');
    this.step2 = this.querySelector('.get-a-quote-form-step[data-step="2"]');
    this.currentStep = 1;
    this.maxSteps = this.dataset.maxSteps;
    this.nextStepButton = this.querySelectorAll(".next-step-button");
    this.previousStepButton = this.querySelector(".previous-step-button");
    this.requiredFields = this.querySelectorAll(
      '.field__input[data-required="true"]'
    );
    this.submitButton = this.querySelector("#submit-button");
    this.initialSubmitButton = this.querySelector("#initial-submit-button");
    this.privacyPolicyCheckbox = this.querySelector("#privacy_policy_checkbox");
    this.countrySelector = this.querySelector("#ContactForm-country");
    this.stepText = this.querySelector(".current-step");
    this.errorMessage = this.querySelector(".get-a-quote-form-error");
  }

  connectedCallback() {
    this.nextStepButton.forEach((button) => {
      button.addEventListener("click", this.nextStep.bind(this));
      button.addEventListener("click", this.updateProgress.bind(this));
    });
    this.previousStepButton.addEventListener(
      "click",
      this.previousStep.bind(this)
    );
    this.previousStepButton.addEventListener(
      "click",
      this.updateProgress.bind(this)
    );
    this.submitButton.addEventListener(
      "click",
      this.checkFieldsCorrectness.bind(this)
    );
  }

  disconnectedCallback() {
    this.nextStepButton.forEach((button) => {
      button.removeEventListener("click", this.nextStep);
      button.removeEventListener("click", this.updateProgress);
    });
    this.previousStepButton.removeEventListener("click", this.previousStep);
    this.previousStepButton.removeEventListener("click", this.updateProgress);
    this.submitButton.removeEventListener("click", this.checkFieldsCorrectness);
  }

  nextStep() {
    this.currentStep++;
    this.step1.classList.add("step-hidden");
    this.step2.classList.remove("step-hidden");
    this.stepText.textContent = this.currentStep;
  }

  previousStep() {
    this.currentStep--;
    this.step1.classList.remove("step-hidden");
    this.step2.classList.add("step-hidden");
    this.stepText.textContent = this.currentStep;
  }

  updateProgress() {
    let progressEl = this.querySelector(".progress-bar");
    let progress = (100 / this.maxSteps) * this.currentStep;
    progressEl.style.width = `${progress}%`;
  }

  checkFieldsCorrectness() {
    let isFormValid = true;

    this.requiredFields.forEach((field) => {
      field.classList.remove("field-error");
    });

    this.requiredFields.forEach((field) => {
      if (field.value === "") {
        field.classList.add("field-error");
        isFormValid = false;
      }
    });

    if (this.privacyPolicyCheckbox.checked) {
      isFormValid = true;
    } else {
      isFormValid = false;
      this.privacyPolicyCheckbox.classList.add("field-error");
    }

    if (this.countrySelector.value !== "") {
      isFormValid = true;
    } else {
      isFormValid = false;
      this.countrySelector.classList.add("field-error");
    }

    if (isFormValid) {
      this.initialSubmitButton.click();
    } else {
      this.errorMessage.classList.add("visible");
      this.errorMessage.classList.remove("hidden");
      window.scrollTo({
        top: this.errorMessage.offsetTop,
        behavior: "smooth",
      });
    }
  }
}

if (!window.customElements.get("get-a-quote")) {
  window.customElements.define("get-a-quote", GetAQuote);
}

document.addEventListener("DOMContentLoaded", function () {
  const quoteForm = document.querySelector(".get-a-quote-form-wrapper form");

  if (quoteForm) {
    quoteForm.addEventListener("submit", async function (e) {
      e.preventDefault();
      const formData = new FormData(this);
      const form = this;

      let productsData = "";
      const productInputs = form.querySelectorAll(
        'input[name^="contact[product-"]'
      );

      productInputs.forEach((input) => {
        const quantity = input.value;
        if (quantity > 0) {
          productsData += `${quantity}, `;
        }
      });

      productsData = productsData.replace(/, $/, "");
      formData.set("contact[products]", productsData);

      try {
        const response = await fetch(
          "https://script.google.com/macros/s/AKfycbwHDjDanD5ju57u2mRJveU8ZvxBMI5w8yydjdslKTpwQJyHlLFidD3hozWw4pkDFWk/exec",
          {
            method: "POST",
            body: formData,
          }
        );
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        form.submit();
      } catch (error) {
        console.error("Error:", error);
        form.submit();
      }
    });
  }
});

document
  .querySelector(".header-item-no-link")
  .addEventListener("click", (e) => {
    e.preventDefault();
  });

document.addEventListener("DOMContentLoaded", function () {
  const cookieBannerSection = document.querySelector("#shopify-pc__banner");
  console.log(window.dataLayer)

  function handleBannerVisibilityChange() {
    const banner = document.querySelector("#shopify-pc__banner");
    if (!banner) return;

    const display = window.getComputedStyle(banner).display;

    if (display !== "none") {
      document.body.style.overflow = "hidden";
      document.querySelector(
        ".shopify-section-header"
      ).style.pointerEvents = "none";
      document.querySelector("#MainContent").style.pointerEvents = "none";
    } else {
      document.body.style.overflow = "";
      document.querySelector(
        ".shopify-section-header"
      ).style.pointerEvents = "";
      document.querySelector("#MainContent").style.pointerEvents = "";
    }
  }

  handleBannerVisibilityChange();

  const observer = new MutationObserver(() => {
    handleBannerVisibilityChange();
  });

  if (cookieBannerSection) {
    observer.observe(cookieBannerSection, {
      attributes: true,
      attributeFilter: ["style"],
    });
  }

  const bannerContainerObserver = new MutationObserver(() => {
    const newBanner = document.querySelector("#shopify-pc__banner");
    if (newBanner) {
      handleBannerVisibilityChange();
      observer.observe(newBanner, {
        attributes: true,
        attributeFilter: ["style"],
      });
      bannerContainerObserver.disconnect();
    }
  });

  if (!cookieBannerSection) {
    bannerContainerObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }
});